const ACTIONS = {
    FETCH_URGENCY_MESSAGE: 'LISTING_EXTENDED/FETCH_URGENCY_MESSAGE', // => middleware
    FETCH_URGENCY_MESSAGE_SUCCESS: 'LISTING_EXTENDED/FETCH_URGENCY_MESSAGE_SUCCESS', // => reducer
    FETCH_BADGES_SUCCESS: 'LISTING_EXTENDED/FETCH_BADGES_SUCCESS',
    FETCH_RANKED_BADGES_SUCCESS: 'LISTING_EXTENDED/FETCH_RANKED_BADGES_SUCCESS',
    FETCH_DISCOVERY_SUCCESS: 'LISTING_EXTENDED/FETCH_DISCOVERY_SUCCESS',
    FETCH_UNIT_SPACES_SUCCESS: 'LISTING_EXTENDED/FETCH_UNIT_SPACES_SUCCESS',
    FETCH_CONTENT_ITEMS_SUCCESS: 'LISTING_EXTENDED/FETCH_CONTENT_ITEMS_SUCCESS',
    FETCH_HOUSE_RULES_SUCCESS: 'LISTING/EXTENDED/FETCH_HOUSE_RULES_SUCCESS',
    FETCH_RECOMMENDED_PROPERTIES_SUCCESS: 'LISTING/FETCH_RECOMMENDED_PROPERTIES_SUCCESS',
    FETCH_RECOMMENDED_PROPERTIES_FAILED: 'LISTING/FETCH_RECOMMENDED_PROPERTIES_FAILED',
    FETCH_REGISTRATION_NUMBER_SUCCESS: 'LISTING/FETCH_REGISTRATION_NUMBER_SUCCESS',
    FETCH_GEO_DISTANCE_SUCCEES: 'LISTING/FETCH_GEO_DISTANCE_SUCCEES'
};

const ACTION_CREATORS = {
    fetchUrgencyMessage() {
        return {
            type: ACTIONS.FETCH_URGENCY_MESSAGE
        };
    },
    fetchUrgencyMessageSuccess(urgencyMessage) {
        return {
            type: ACTIONS.FETCH_URGENCY_MESSAGE_SUCCESS,
            payload: {
                urgencyMessage
            }
        };
    },
    fetchBadgesSuccess(badges) {
        return {
            type: ACTIONS.FETCH_BADGES_SUCCESS,
            payload: {
                badges
            }
        };
    },
    fetchRankedBadgesSuccess(rankedBadges) {
        return {
            type: ACTIONS.FETCH_RANKED_BADGES_SUCCESS,
            payload: {
                rankedBadges
            }
        };
    },
    fetchDiscoveryFeedSuccess(discoveryFeed) {
        return {
            type: ACTIONS.FETCH_DISCOVERY_SUCCESS,
            payload: {
                discoveryFeed
            }
        };
    },
    fetchUnitSpacesSuccess(unitSpaces) {
        return {
            type: ACTIONS.FETCH_UNIT_SPACES_SUCCESS,
            payload: {
                unitSpaces
            }
        };
    },
    fetchContentItemsSuccess(unitContentItems, propertyContentItems, unitMetadata) {
        return {
            type: ACTIONS.FETCH_CONTENT_ITEMS_SUCCESS,
            payload: {
                unitContentItems,
                propertyContentItems,
                unitMetadata
            }
        };
    },
    fetchHouseRulesSuccess(houseRules) {
        return {
            type: ACTIONS.FETCH_HOUSE_RULES_SUCCESS,
            payload: {
                houseRules
            }
        };
    },
    fetchRecommendedPropertiesSuccess(recommendedProperties) {
        return {
            type: ACTIONS.FETCH_RECOMMENDED_PROPERTIES_SUCCESS,
            payload: {
                recommendedProperties
            }
        };
    },
    fetchRecommendedPropertiesFailed() {
        return {
            type: ACTIONS.FETCH_RECOMMENDED_PROPERTIES_FAILED,
            payload: {}
        };
    },
    fetchRegistrationNumberSuccess(registrationNumber) {
        return {
            type: ACTIONS.FETCH_REGISTRATION_NUMBER_SUCCESS,
            payload: {
                registrationNumber
            }
        };
    },
    fetchGeoDistanceSuccess(geoRelativeDistances) {
        return {
            type: ACTIONS.FETCH_GEO_DISTANCE_SUCCEES,
            payload: {
                geoRelativeDistances
            }
        };
    }
};

export default {...ACTIONS, ...ACTION_CREATORS};
